import React, { useEffect, useState } from 'react';
import './FormFields.css';
import { trackTravellersEvent } from '../../../../../utils/railsAnalytics';

const Input = (props) => {
  const [ state, setState ] = useState({
    value: props.value || '',
    validationFail: props.validationFail || false,
    inputFocus: false,
    autoFocus: props.autoFocus,
    textStyle: props.textStyle || '',
  });

  const {
    labelName,
    labelDesc,
    additionalAttributes,
    type,
    errorMessage,
    renderData,
    fieldId,
    fieldName,
    vaidationMsg,
    vaidationStatus,
    vaidationMoreMsg,
    vaidationMoreStatus,
    render,
    readOnly,
    labelRight,
    labelRightFont,
    onClick,
    style,
  } = props;

  useEffect(() => {
    setState({
          ...state,
          validationFail: props.validationFail,
          value: props.value,
        });
  }, [props]);

  const handleValueChange = (event) => {
    setState({
      ...state,
      value: event.target.value.trim(),
    });
    props.handleInputKeyUpViaParent && props.handleInputKeyUpViaParent(event.target.value.trim());
  };
  const handleInputFocus = () => {
    setState({
      ...state,
      inputFocus: !state.inputFocus,
    });
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && props.onEnterClick) {
      props.onEnterClick();
    }
  }

  const goToFieldChangePage = () => {
    props.showModal && props.showModal();
    trackTravellersEvent('request_irctc_password_clicked');
    if (props.switchModal) {
      props.switchModal(props.onChangePage,
        {
          userId: props.irctcUserId,
          mobileEntered: props.mobileNumber,
        });
    }
  };

  const { validationFail, value, inputFocus, autoFocus, textStyle } = state;
    return (
      <div
        className={`inputFieldWrapper ${render ? 'twoComponent' : ''} ${
          validationFail ? 'validationError' : ''
        }`}
      >
        {(labelName || labelDesc) && (
          <label
            className="font14 latoBold makeFlex InputField"
            htmlFor={fieldId}
          >
            {labelName && (
              <span className={`${style ? style : 'darkGreyText labelName'}`}>{labelName}</span>
            )}
            {labelDesc && (
              <span className="latoRegular font12 lightGreyText labelDesc">
                {labelDesc}
              </span>
            )}
          </label>
        )}
        <div
          className={`makeFlex hrtlCenter spaceBetween ${style ? 'fieldsWrapper' : 'filedsWrapper'} ${inputFocus ? 'blueBorder' : ''}`}
          role="button"
        >
          <div className="makeFlex fullWidth" style={{ color: readOnly ? 'lightgrey' : '' }}>
            {render && render(renderData)}
            <input
              type={type}
              value={value}
              readOnly={readOnly}
              className={`${readOnly ? 'font14 latoRegular InputFieldElement lightgrey' : (textStyle ? textStyle : 'InputFieldElement darkGreyText font14 latoRegular') }`}
              name={fieldName}
              id={fieldId}
              onChange={handleValueChange}
              onFocus={handleInputFocus}
              onKeyPress={handleKeyPress}
              onBlur={handleInputFocus}
              spellCheck="false"
              maxLength="35"
              {...additionalAttributes}
              autoFocus={autoFocus}
            />
          </div>
          {vaidationMsg && (
            <a
              className={`font12 latoBold shrinkZero ${
                vaidationStatus
                  ? 'greenText vaidationSuccess appendLeft20'
                  : 'deepskyBlueText vaidationFail appendLeft5'
              }`}
            >
              {vaidationMsg}
            </a>
          )}
          {vaidationMoreMsg && (
            <a
              className={`font12 latoBold shrinkZero ${
                vaidationMoreStatus
                  ? 'greenText vaidationSuccess appendLeft20'
                  : 'deepskyBlueText vaidationFail appendLeft5'
              }`}
              onClick={goToFieldChangePage}
            >
              {vaidationMoreMsg}
            </a>
          )}
          {labelRight && <a onClick={onClick} className={`makeFlex hrtlCenter deepskyBlueText deepBlue appendRight15  ${labelRightFont}`}>{labelRight}<span className="railSprite blueArrowLong appendLeft10"></span></a>}
        </div>
        {errorMessage &&
        validationFail &&
        (
          <p className="font12 redText appendTop10 errorMsg">
            {errorMessage}
          </p>
        )}
      </div>
    );
  }

export default Input;
